const customerAndProductPlatformFeatures = [
  {
    feature: '360 Customer Profiles (CDP)',
    //startup: true,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: '360 Product Profile (PDP)',
    //startup: true,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Product Trends',
    //startup: false,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Import customers',
    //startup: true,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Customer segmentation',
    //startup: true,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Emails',
    //startup: false,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Triggered campaigns',
    //startup: false,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  {
    feature: 'Analytics',
    //startup: false,
    Growth: false,
    Standard: true,
    Enterprise: true,
  },
  // {
  //   feature: 'Pop-up and banners',
  //   //startup: false,
  //   Growth: false,
  //   Standard: true,
  //   Enterprise: true,
  // },
  // {
  //   feature: 'Post-Purchase',
  //   //startup: false,
  //   Growth: false,
  //   Standard: true,
  //   Enterprise: true,
  // },
  // {
  //   feature: 'Analytics',
  //   //startup: false,
  //   Growth: false,
  //   Standard: true,
  //   Enterprise: true,
  // },
];

export default customerAndProductPlatformFeatures;
